import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "users-list" }
const _hoisted_2 = {
  key: 0,
  class: "mt-6 grid grid-cols-1 gap-y-4"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IpgTransactionSkelton = _resolveComponent("IpgTransactionSkelton")!
  const _component_LogsSysytemTableComponent = _resolveComponent("LogsSysytemTableComponent")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.getLoadingPanel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createVNode(_component_IpgTransactionSkelton, { key: index })
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_LogsSysytemTableComponent, { logs: _ctx.getSystemLogs }, null, 8, ["logs"]),
            (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
              ? (_openBlock(), _createBlock(_component_CustomPaginationComponent, {
                  key: 0,
                  "total-items": _ctx.getGlobalPagination.total,
                  "items-per-page": 50,
                  onPageChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handelPagination()))
                }, null, 8, ["total-items"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}